import styled from 'styled-components';

const Content = styled.div`
  form {
    display: flex;
    flex-direction: column;

    > div {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      grid-gap: 15px;
      margin-bottom: 20px;
    }

    button {
      align-self: flex-end;
      width: 100px;
    }
  }
`;

export default Content;
